import { useState, useEffect, useRef, useCallback } from "react";
import { trackEvent, fetchAdminStats } from "./lib/analytics";
import JSZip from 'jszip';

// ─── SVG Icons ───────────────────────────────────────────────────────────────

const CheckIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);
const LockIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);
const ArrowRight = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);
const CoffeeIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 8h1a4 4 0 0 1 0 8h-1" />
    <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z" />
    <line x1="6" y1="1" x2="6" y2="4" />
    <line x1="10" y1="1" x2="10" y2="4" />
    <line x1="14" y1="1" x2="14" y2="4" />
  </svg>
);
const AlertIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);
const ShieldIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);
const FolderIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
  </svg>
);
const MessageIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
);
const RefreshIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="23 4 23 10 17 10" />
    <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
  </svg>
);
const BarChartIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="20" x2="18" y2="10" />
    <line x1="12" y1="20" x2="12" y2="4" />
    <line x1="6" y1="20" x2="6" y2="14" />
  </svg>
);
const UsersIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);
const LogOutIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </svg>
);
const EyeIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);
const TrendUpIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
    <polyline points="17 6 23 6 23 12" />
  </svg>
);
const WarningIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);
const HeartIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" stroke="none">
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
  </svg>
);
const UploadIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="17 8 12 3 7 8" />
    <line x1="12" y1="3" x2="12" y2="15" />
  </svg>
);

// ─── Simulated Backend Analytics Store ───────────────────────────────────────

const createAnalyticsStore = () => {
  const now = Date.now();
  const day = 86400000;
  return {
    totalVisitors: 14832,
    openaiAuths: 6241,
    claudeAuths: 5987,
    completedMigrations: 4156,
    failedMigrations: 83,
    avgMigrationTime: "2m 34s",
    conversionRate: "28.0%",
    dailyStats: [
      { date: "Apr 7", visitors: 1842, openai: 812, claude: 779, migrations: 534 },
      { date: "Apr 8", visitors: 2105, openai: 923, claude: 891, migrations: 612 },
      { date: "Apr 9", visitors: 1956, openai: 834, claude: 802, migrations: 558 },
      { date: "Apr 10", visitors: 2340, openai: 1021, claude: 987, migrations: 689 },
      { date: "Apr 11", visitors: 2567, openai: 1098, claude: 1054, migrations: 741 },
      { date: "Apr 12", visitors: 2189, openai: 934, claude: 897, migrations: 621 },
      { date: "Apr 13", visitors: 1833, openai: 619, claude: 577, migrations: 401 },
    ],
    recentEvents: [
      { time: "2 min ago", event: "Migration completed", user: "user_8a3f...d21c", status: "success" },
      { time: "5 min ago", event: "OpenAI auth", user: "user_1bc4...e9a7", status: "info" },
      { time: "8 min ago", event: "Migration started", user: "user_6d2e...f4b0", status: "pending" },
      { time: "12 min ago", event: "Claude auth", user: "user_3ef1...a82d", status: "info" },
      { time: "15 min ago", event: "Migration failed", user: "user_9ca0...b31f", status: "error" },
      { time: "18 min ago", event: "Migration completed", user: "user_7fb2...c45e", status: "success" },
      { time: "23 min ago", event: "New visitor", user: "user_4de8...g67h", status: "info" },
      { time: "31 min ago", event: "Migration completed", user: "user_2ab5...h91i", status: "success" },
    ],
  };
};

// ─── Global Styles ───────────────────────────────────────────────────────────

const GlobalStyles = () => (
  <style>{`
    @keyframes drift { 0%, 100% { transform: translate(0, 0); } 50% { transform: translate(-2%, 2%); } }
    @keyframes fadeUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
    @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
    @keyframes spin { to { transform: rotate(360deg); } }
    @keyframes slideIn { from { opacity: 0; transform: translateX(-10px); } to { opacity: 1; transform: translateX(0); } }
    @keyframes checkPop { 0% { transform: scale(0); } 50% { transform: scale(1.2); } 100% { transform: scale(1); } }
    @keyframes pulseGlow { 0%, 100% { box-shadow: 0 0 0 0 rgba(251,191,36,0.3); } 50% { box-shadow: 0 0 20px 4px rgba(251,191,36,0.15); } }
    @keyframes shimmer { 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } }
    @keyframes barGrow { from { transform: scaleY(0); } to { transform: scaleY(1); } }
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body { overflow-x: hidden; }
    input::placeholder { color: rgba(255,255,255,0.25); }
    ::-webkit-scrollbar { width: 6px; }
    ::-webkit-scrollbar-track { background: transparent; }
    ::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 3px; }
  `}</style>
);

// ─── Animated Background ─────────────────────────────────────────────────────

const AnimatedBackground = () => (
  <div style={{
    position: "fixed", inset: 0, zIndex: 0, overflow: "hidden",
    background: "linear-gradient(135deg, #0f0f1a 0%, #1a1a2e 25%, #16213e 50%, #1a1a2e 75%, #0f0f1a 100%)"
  }}>
    <div style={{
      position: "absolute", top: "-50%", left: "-50%", width: "200%", height: "200%",
      background: "radial-gradient(ellipse at 30% 20%, rgba(139,92,246,0.08) 0%, transparent 50%), radial-gradient(ellipse at 70% 80%, rgba(217,119,87,0.06) 0%, transparent 50%)",
      animation: "drift 20s ease-in-out infinite"
    }} />
  </div>
);

// ─── Reusable Components ─────────────────────────────────────────────────────

const Card = ({ children, style, delay = 0 }) => (
  <div style={{
    background: "rgba(255,255,255,0.03)", backdropFilter: "blur(20px)",
    border: "1px solid rgba(255,255,255,0.08)", borderRadius: "20px", padding: "32px",
    animation: `fadeUp 0.6s ease ${delay}s both`, ...style
  }}>
    {children}
  </div>
);

const ProcessItem = ({ label, done, delay }) => (
  <div style={{
    display: "flex", alignItems: "center", gap: "12px", padding: "12px 16px", borderRadius: "10px",
    background: done ? "rgba(52,211,153,0.06)" : "rgba(255,255,255,0.02)",
    border: `1px solid ${done ? "rgba(52,211,153,0.15)" : "rgba(255,255,255,0.04)"}`,
    animation: `slideIn 0.4s ease ${delay}s both`, transition: "all 0.3s ease"
  }}>
    <div style={{ color: done ? "#34d399" : "rgba(255,255,255,0.3)" }}>
      {done ? <CheckIcon size={16} /> : <div style={{ width: 16, height: 16, borderRadius: "50%", background: "rgba(255,255,255,0.1)" }} />}
    </div>
    <div style={{ flex: 1 }}>
      <div style={{ color: "#fff", fontSize: "14px", fontWeight: 500 }}>{label}</div>
    </div>
    {done && <div style={{ color: "#34d399", animation: "checkPop 0.4s ease" }}><CheckIcon size={16} /></div>}
  </div>
);

// ─── Buy Me a Coffee Floating Widget ─────────────────────────────────────────

const BuyMeCoffeeWidget = () => {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        position: "fixed", bottom: "24px", right: "24px", zIndex: 1000,
        animation: "fadeUp 0.8s ease 1s both"
      }}
    >
      {/* Tooltip */}
      <div style={{
        position: "absolute", bottom: "72px", right: "0",
        background: "rgba(30,30,50,0.95)", backdropFilter: "blur(12px)",
        border: "1px solid rgba(251,191,36,0.2)", borderRadius: "14px",
        padding: "16px 20px", width: "240px",
        opacity: hovered ? 1 : 0, transform: hovered ? "translateY(0)" : "translateY(8px)",
        transition: "all 0.3s ease", pointerEvents: hovered ? "auto" : "none"
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "8px" }}>
          <span style={{ color: "#fbbf24" }}><HeartIcon /></span>
          <span style={{ color: "#fff", fontSize: "14px", fontWeight: 600 }}>Support this project</span>
        </div>
        <p style={{ color: "rgba(255,255,255,0.5)", fontSize: "12px", lineHeight: 1.5, margin: "0 0 12px 0" }}>
          If you found this tool valuable, feel free to buy me a coffee — it's greatly appreciated!
        </p>
        <a
          href="https://buymeacoffee.com"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "flex", alignItems: "center", justifyContent: "center", gap: "8px",
            padding: "10px 16px", background: "#FFDD00", color: "#000",
            border: "none", borderRadius: "8px", fontSize: "13px", fontWeight: 700,
            cursor: "pointer", textDecoration: "none", width: "100%"
          }}
        >
          <CoffeeIcon size={16} /> Buy Me a Coffee
        </a>
      </div>

      {/* Floating button */}
      <button
        onClick={() => window.open("https://buymeacoffee.com", "_blank")}
        style={{
          width: "56px", height: "56px", borderRadius: "50%",
          background: "linear-gradient(135deg, #FFDD00, #FFB800)",
          border: "none", cursor: "pointer",
          display: "flex", alignItems: "center", justifyContent: "center",
          boxShadow: hovered
            ? "0 8px 32px rgba(251,191,36,0.4)"
            : "0 4px 20px rgba(251,191,36,0.25)",
          transform: hovered ? "scale(1.1)" : "scale(1)",
          transition: "all 0.3s ease",
          animation: "pulseGlow 3s ease-in-out infinite"
        }}
      >
        <CoffeeIcon size={24} />
      </button>
    </div>
  );
};

// ─── Page Leave Warning Overlay ──────────────────────────────────────────────

const LeaveWarningOverlay = ({ onStay }) => (
  <div style={{
    position: "fixed", inset: 0, zIndex: 9999,
    background: "rgba(0,0,0,0.8)", backdropFilter: "blur(8px)",
    display: "flex", alignItems: "center", justifyContent: "center",
    animation: "fadeIn 0.2s ease"
  }}>
    <div style={{
      background: "rgba(30,30,50,0.95)", border: "1px solid rgba(255,100,100,0.3)",
      borderRadius: "20px", padding: "40px", maxWidth: "420px", textAlign: "center",
      animation: "fadeUp 0.3s ease"
    }}>
      <div style={{
        width: "56px", height: "56px", borderRadius: "50%",
        background: "rgba(239,68,68,0.15)", border: "2px solid rgba(239,68,68,0.3)",
        display: "flex", alignItems: "center", justifyContent: "center",
        margin: "0 auto 20px", color: "#ef4444"
      }}>
        <WarningIcon />
      </div>
      <h3 style={{ color: "#fff", fontSize: "20px", fontWeight: 700, margin: "0 0 8px 0" }}>
        Migration in Progress
      </h3>
      <p style={{ color: "rgba(255,255,255,0.5)", fontSize: "14px", lineHeight: 1.6, margin: "0 0 24px 0" }}>
        Please don't leave this page. Your data is actively being transferred and leaving now may result in an incomplete migration.
      </p>
      <button onClick={onStay} style={{
        padding: "12px 32px", background: "linear-gradient(135deg, #8b5cf6, #7c3aed)",
        color: "#fff", border: "none", borderRadius: "10px",
        fontSize: "14px", fontWeight: 600, cursor: "pointer",
        boxShadow: "0 4px 16px rgba(139,92,246,0.3)"
      }}>
        Stay on Page
      </button>
    </div>
  </div>
);

// ─── Admin Dashboard ─────────────────────────────────────────────────────────

const AdminDashboard = ({ onLogout }) => {
  const [stats] = useState(createAnalyticsStore);

  const StatCard = ({ label, value, icon, color, subtext }) => (
    <div style={{
      background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.08)",
      borderRadius: "16px", padding: "24px", flex: 1, minWidth: "200px"
    }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px" }}>
        <div style={{
          width: "40px", height: "40px", borderRadius: "10px", background: color + "15",
          display: "flex", alignItems: "center", justifyContent: "center", color: color
        }}>
          {icon}
        </div>
        {subtext && (
          <div style={{
            display: "flex", alignItems: "center", gap: "4px",
            fontSize: "12px", color: "#34d399", fontWeight: 600
          }}>
            <TrendUpIcon /> {subtext}
          </div>
        )}
      </div>
      <div style={{ color: "#fff", fontSize: "28px", fontWeight: 700, marginBottom: "4px" }}>
        {typeof value === "number" ? value.toLocaleString() : value}
      </div>
      <div style={{ color: "rgba(255,255,255,0.4)", fontSize: "13px" }}>{label}</div>
    </div>
  );

  const maxVisitors = Math.max(...stats.dailyStats.map(d => d.visitors));

  return (
    <div style={{ position: "relative", zIndex: 1, maxWidth: "960px", margin: "0 auto", padding: "32px 24px" }}>
      {/* Admin header */}
      <div style={{
        display: "flex", alignItems: "center", justifyContent: "space-between",
        marginBottom: "32px", animation: "fadeUp 0.5s ease both"
      }}>
        <div>
          <div style={{
            display: "inline-flex", alignItems: "center", gap: "6px",
            background: "rgba(139,92,246,0.1)", border: "1px solid rgba(139,92,246,0.2)",
            borderRadius: "100px", padding: "4px 12px", marginBottom: "12px",
            fontSize: "11px", fontWeight: 600, color: "#a78bfa", textTransform: "uppercase", letterSpacing: "0.05em"
          }}>
            <BarChartIcon /> Admin Dashboard
          </div>
          <h1 style={{ color: "#fff", fontSize: "28px", fontWeight: 700, margin: 0 }}>Analytics Overview</h1>
          <p style={{ color: "rgba(255,255,255,0.4)", fontSize: "14px", marginTop: "4px" }}>
            Real-time migration statistics · Last 7 days
          </p>
        </div>
        <button onClick={onLogout} style={{
          display: "flex", alignItems: "center", gap: "6px",
          padding: "10px 18px", background: "rgba(255,255,255,0.05)",
          border: "1px solid rgba(255,255,255,0.1)", borderRadius: "10px",
          color: "rgba(255,255,255,0.6)", fontSize: "13px", fontWeight: 500, cursor: "pointer"
        }}>
          <LogOutIcon /> Log Out
        </button>
      </div>

      {/* Stat cards */}
      <div style={{
        display: "flex", gap: "16px", flexWrap: "wrap", marginBottom: "24px",
        animation: "fadeUp 0.5s ease 0.1s both"
      }}>
        <StatCard label="Total Visitors" value={stats.totalVisitors} icon={<EyeIcon />} color="#60a5fa" subtext="+12.3%" />
        <StatCard label="OpenAI Auths" value={stats.openaiAuths} icon={<UsersIcon />} color="#10a37f" subtext="+8.7%" />
        <StatCard label="Claude Auths" value={stats.claudeAuths} icon={<UsersIcon />} color="#d97757" subtext="+9.1%" />
        <StatCard label="Migrations Done" value={stats.completedMigrations} icon={<CheckIcon size={18} />} color="#34d399" subtext="+15.2%" />
      </div>

      {/* Second row */}
      <div style={{
        display: "flex", gap: "16px", flexWrap: "wrap", marginBottom: "24px",
        animation: "fadeUp 0.5s ease 0.15s both"
      }}>
        <StatCard label="Failed Migrations" value={stats.failedMigrations} icon={<AlertIcon />} color="#ef4444" />
        <StatCard label="Avg. Migration Time" value={stats.avgMigrationTime} icon={<RefreshIcon />} color="#a78bfa" />
        <StatCard label="Conversion Rate" value={stats.conversionRate} icon={<TrendUpIcon />} color="#fbbf24" subtext="+2.1%" />
      </div>

      {/* Chart + Activity */}
      <div style={{ display: "flex", gap: "16px", flexWrap: "wrap", animation: "fadeUp 0.5s ease 0.2s both" }}>
        {/* Bar chart */}
        <div style={{
          flex: "2 1 400px", background: "rgba(255,255,255,0.03)",
          border: "1px solid rgba(255,255,255,0.08)", borderRadius: "16px", padding: "24px"
        }}>
          <h3 style={{ color: "#fff", fontSize: "16px", fontWeight: 600, margin: "0 0 4px 0" }}>Daily Traffic</h3>
          <p style={{ color: "rgba(255,255,255,0.35)", fontSize: "12px", margin: "0 0 24px 0" }}>Visitors per day over the last week</p>
          <div style={{ display: "flex", alignItems: "flex-end", gap: "12px", height: "160px" }}>
            {stats.dailyStats.map((day, i) => {
              const h = (day.visitors / maxVisitors) * 140;
              return (
                <div key={day.date} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
                  <div style={{ position: "relative", width: "100%", display: "flex", justifyContent: "center" }}>
                    <div style={{
                      width: "100%", maxWidth: "40px", height: `${h}px`, borderRadius: "6px 6px 2px 2px",
                      background: `linear-gradient(180deg, #8b5cf6, ${i === stats.dailyStats.length - 1 ? "#d97757" : "#6d28d9"})`,
                      transformOrigin: "bottom", animation: `barGrow 0.6s ease ${0.1 * i}s both`,
                      opacity: 0.85
                    }} />
                  </div>
                  <span style={{ color: "rgba(255,255,255,0.35)", fontSize: "11px" }}>{day.date}</span>
                </div>
              );
            })}
          </div>
        </div>

        {/* Recent activity */}
        <div style={{
          flex: "1 1 300px", background: "rgba(255,255,255,0.03)",
          border: "1px solid rgba(255,255,255,0.08)", borderRadius: "16px", padding: "24px"
        }}>
          <h3 style={{ color: "#fff", fontSize: "16px", fontWeight: 600, margin: "0 0 4px 0" }}>Recent Activity</h3>
          <p style={{ color: "rgba(255,255,255,0.35)", fontSize: "12px", margin: "0 0 16px 0" }}>Live event stream</p>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px", maxHeight: "240px", overflowY: "auto" }}>
            {stats.recentEvents.map((evt, i) => {
              const statusColors = { success: "#34d399", error: "#ef4444", info: "#60a5fa", pending: "#fbbf24" };
              return (
                <div key={i} style={{
                  display: "flex", alignItems: "center", gap: "10px",
                  padding: "10px 12px", borderRadius: "8px",
                  background: "rgba(255,255,255,0.02)",
                  border: "1px solid rgba(255,255,255,0.04)",
                  animation: `slideIn 0.3s ease ${0.05 * i}s both`
                }}>
                  <div style={{
                    width: "8px", height: "8px", borderRadius: "50%",
                    background: statusColors[evt.status],
                    boxShadow: `0 0 8px ${statusColors[evt.status]}40`,
                    flexShrink: 0
                  }} />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ color: "#fff", fontSize: "12px", fontWeight: 500 }}>{evt.event}</div>
                    <div style={{ color: "rgba(255,255,255,0.3)", fontSize: "11px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {evt.user}
                    </div>
                  </div>
                  <div style={{ color: "rgba(255,255,255,0.25)", fontSize: "11px", whiteSpace: "nowrap", flexShrink: 0 }}>
                    {evt.time}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Funnel breakdown */}
      <div style={{
        marginTop: "24px", background: "rgba(255,255,255,0.03)",
        border: "1px solid rgba(255,255,255,0.08)", borderRadius: "16px", padding: "24px",
        animation: "fadeUp 0.5s ease 0.3s both"
      }}>
        <h3 style={{ color: "#fff", fontSize: "16px", fontWeight: 600, margin: "0 0 16px 0" }}>Conversion Funnel</h3>
        <div style={{ display: "flex", alignItems: "center", gap: "0" }}>
          {[
            { label: "Visitors", value: stats.totalVisitors, color: "#60a5fa", pct: "100%" },
            { label: "OpenAI Auth", value: stats.openaiAuths, color: "#10a37f", pct: ((stats.openaiAuths / stats.totalVisitors) * 100).toFixed(1) + "%" },
            { label: "Claude Auth", value: stats.claudeAuths, color: "#d97757", pct: ((stats.claudeAuths / stats.totalVisitors) * 100).toFixed(1) + "%" },
            { label: "Completed", value: stats.completedMigrations, color: "#34d399", pct: ((stats.completedMigrations / stats.totalVisitors) * 100).toFixed(1) + "%" },
          ].map((step, i, arr) => (
            <div key={step.label} style={{ flex: 1, display: "flex", alignItems: "center" }}>
              <div style={{ flex: 1, textAlign: "center", padding: "16px 8px" }}>
                <div style={{ color: step.color, fontSize: "24px", fontWeight: 700 }}>{step.value.toLocaleString()}</div>
                <div style={{ color: "rgba(255,255,255,0.4)", fontSize: "12px", marginTop: "4px" }}>{step.label}</div>
                <div style={{
                  display: "inline-block", marginTop: "6px", padding: "2px 8px",
                  background: step.color + "15", borderRadius: "100px",
                  fontSize: "11px", fontWeight: 600, color: step.color
                }}>
                  {step.pct}
                </div>
              </div>
              {i < arr.length - 1 && (
                <div style={{ color: "rgba(255,255,255,0.15)", flexShrink: 0 }}>
                  <ArrowRight />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

// ─── Admin Login Screen ──────────────────────────────────────────────────────

const AdminLogin = ({ onLogin, onBack }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    if (!email || !password) { setError("Please fill in all fields."); return; }
    setLoading(true);
    setTimeout(() => {
      if (email === "admin@migrate.app" && password === "admin123") {
        onLogin();
      } else {
        setError("Invalid credentials. Try admin@migrate.app / admin123");
        setLoading(false);
      }
    }, 1200);
  };

  return (
    <div style={{
      position: "relative", zIndex: 1, maxWidth: "420px", margin: "0 auto",
      padding: "80px 24px", animation: "fadeUp 0.5s ease both"
    }}>
      <div style={{ textAlign: "center", marginBottom: "32px" }}>
        <div style={{
          width: "56px", height: "56px", borderRadius: "14px",
          background: "rgba(139,92,246,0.15)", border: "1px solid rgba(139,92,246,0.3)",
          display: "flex", alignItems: "center", justifyContent: "center",
          margin: "0 auto 20px", color: "#a78bfa"
        }}>
          <ShieldIcon size={28} />
        </div>
        <h2 style={{ color: "#fff", fontSize: "24px", fontWeight: 700, margin: "0 0 8px 0" }}>Admin Access</h2>
        <p style={{ color: "rgba(255,255,255,0.4)", fontSize: "14px" }}>Sign in to view migration analytics</p>
      </div>

      <Card>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "16px" }}>
            <label style={{ display: "block", color: "rgba(255,255,255,0.5)", fontSize: "12px", fontWeight: 600, marginBottom: "6px", textTransform: "uppercase", letterSpacing: "0.05em" }}>
              Email
            </label>
            <input
              type="email" value={email} onChange={e => setEmail(e.target.value)}
              placeholder="admin@migrate.app"
              style={{
                width: "100%", padding: "12px 16px", background: "rgba(255,255,255,0.05)",
                border: "1px solid rgba(255,255,255,0.1)", borderRadius: "10px",
                color: "#fff", fontSize: "14px", outline: "none", transition: "border 0.3s"
              }}
              onFocus={e => e.target.style.borderColor = "rgba(139,92,246,0.5)"}
              onBlur={e => e.target.style.borderColor = "rgba(255,255,255,0.1)"}
            />
          </div>
          <div style={{ marginBottom: "20px" }}>
            <label style={{ display: "block", color: "rgba(255,255,255,0.5)", fontSize: "12px", fontWeight: 600, marginBottom: "6px", textTransform: "uppercase", letterSpacing: "0.05em" }}>
              Password
            </label>
            <input
              type="password" value={password} onChange={e => setPassword(e.target.value)}
              placeholder="Enter password"
              style={{
                width: "100%", padding: "12px 16px", background: "rgba(255,255,255,0.05)",
                border: "1px solid rgba(255,255,255,0.1)", borderRadius: "10px",
                color: "#fff", fontSize: "14px", outline: "none", transition: "border 0.3s"
              }}
              onFocus={e => e.target.style.borderColor = "rgba(139,92,246,0.5)"}
              onBlur={e => e.target.style.borderColor = "rgba(255,255,255,0.1)"}
            />
          </div>

          {error && (
            <div style={{
              padding: "10px 14px", background: "rgba(239,68,68,0.1)",
              border: "1px solid rgba(239,68,68,0.2)", borderRadius: "8px",
              color: "#ef4444", fontSize: "13px", marginBottom: "16px",
              display: "flex", alignItems: "center", gap: "8px"
            }}>
              <AlertIcon /> {error}
            </div>
          )}

          <button type="submit" disabled={loading} style={{
            width: "100%", padding: "14px", background: "linear-gradient(135deg, #8b5cf6, #7c3aed)",
            color: "#fff", border: "none", borderRadius: "10px",
            fontSize: "15px", fontWeight: 600, cursor: "pointer",
            opacity: loading ? 0.7 : 1, display: "flex", alignItems: "center", justifyContent: "center", gap: "8px",
            boxShadow: "0 4px 16px rgba(139,92,246,0.3)"
          }}>
            {loading ? (
              <div style={{ width: "18px", height: "18px", border: "2px solid rgba(255,255,255,0.3)", borderTopColor: "#fff", borderRadius: "50%", animation: "spin 0.8s linear infinite" }} />
            ) : "Sign In"}
          </button>
        </form>

        <div style={{ textAlign: "center", marginTop: "16px" }}>
          <button onClick={onBack} style={{
            background: "none", border: "none", color: "rgba(255,255,255,0.35)",
            fontSize: "13px", cursor: "pointer", padding: "4px"
          }}>
            &larr; Back to Migration Tool
          </button>
        </div>
      </Card>

      <div style={{
        textAlign: "center", marginTop: "20px", padding: "12px 16px",
        background: "rgba(139,92,246,0.06)", border: "1px solid rgba(139,92,246,0.15)",
        borderRadius: "10px", maxWidth: "320px", margin: "20px auto 0"
      }}>
        <div style={{ color: "rgba(255,255,255,0.35)", fontSize: "11px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "6px" }}>
          Demo Credentials
        </div>
        <div style={{ color: "rgba(255,255,255,0.5)", fontSize: "13px", lineHeight: 1.6 }}>
          <span style={{ color: "#a78bfa" }}>Email:</span> admin@migrate.app<br />
          <span style={{ color: "#a78bfa" }}>Password:</span> admin123
        </div>
      </div>
    </div>
  );
};

// ─── ZIP Parser Function ─────────────────────────────────────────────────────

async function parseExportZip(file) {
  try {
    const arrayBuffer = await file.arrayBuffer();
    const zip = new JSZip();
    await zip.loadAsync(arrayBuffer);

    const conversationsJson = zip.file("conversations.json");
    if (!conversationsJson) {
      throw new Error("conversations.json not found in ZIP");
    }

    const jsonText = await conversationsJson.async("text");
    const conversations = JSON.parse(jsonText);

    if (!Array.isArray(conversations)) {
      throw new Error("conversations.json is not an array");
    }

    const totalMessages = conversations.reduce((sum, conv) => {
      const messages = conv.mapping || {};
      return sum + Object.keys(messages).length;
    }, 0);

    const dates = conversations
      .map(conv => conv.create_time ? new Date(conv.create_time * 1000) : null)
      .filter(d => d !== null);

    const dateRange = dates.length > 0
      ? `${new Date(Math.min(...dates)).toLocaleDateString()} - ${new Date(Math.max(...dates)).toLocaleDateString()}`
      : "Unknown";

    return {
      conversations,
      totalMessages,
      dateRange,
      count: conversations.length
    };
  } catch (error) {
    throw new Error(`Failed to parse ZIP: ${error.message}`);
  }
}

// ─── Generate Claude Output ─────────────────────────────────────────────────

function generateClaudeOutput(parsedData) {
  const { conversations } = parsedData;

  let markdown = `# Migrated ChatGPT Conversations

**Migration Date:** ${new Date().toLocaleDateString()}
**Total Conversations:** ${conversations.length}
**Total Messages:** ${parsedData.totalMessages}

---

`;

  conversations.forEach((conv, idx) => {
    const title = conv.title || `Conversation ${idx + 1}`;
    const createDate = conv.create_time ? new Date(conv.create_time * 1000).toLocaleDateString() : "Unknown";

    markdown += `## ${idx + 1}. ${title}\n`;
    markdown += `**Date:** ${createDate}\n\n`;

    const messages = conv.mapping || {};
    Object.values(messages).forEach((msg) => {
      if (msg.message && msg.message.content && msg.message.content.parts) {
        const role = msg.message.author.role === "user" ? "You" : "ChatGPT";
        const content = msg.message.content.parts.join(" ");
        markdown += `**${role}:** ${content}\n\n`;
      }
    });

    markdown += `---\n\n`;
  });

  return markdown;
}

// ─── Main App ────────────────────────────────────────────────────────────────

export default function MigrationApp() {
  const [page, setPage] = useState("main"); // main | admin-login | admin
  const [step, setStep] = useState("upload"); // upload | processing | done
  const [parsedData, setParsedData] = useState(null);
  const [uploadError, setUploadError] = useState(null);
  const [processingProgress, setProcessingProgress] = useState(0);
  const [processingItems, setProcessingItems] = useState([false, false, false, false]);
  const [showLeaveWarning, setShowLeaveWarning] = useState(false);
  const [donationDismissed, setDonationDismissed] = useState(false);
  const timerRef = useRef(null);
  const fileInputRef = useRef(null);
  const isMigrating = step === "processing";

  // Track visitor on mount
  useEffect(() => { trackEvent("page_visit"); }, []);

  // Page-leave prevention during migration
  useEffect(() => {
    if (!isMigrating) return;

    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = "Processing in progress. Are you sure you want to leave?";
      return e.returnValue;
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden" && isMigrating) {
        setShowLeaveWarning(true);
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [isMigrating]);

  const handleFileSelect = async (file) => {
    if (!file) return;

    setUploadError(null);
    try {
      trackEvent("file_uploaded");
      const data = await parseExportZip(file);
      setParsedData(data);
    } catch (error) {
      setUploadError(error.message);
      trackEvent("upload_error");
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.style.borderColor = "rgba(139,92,246,0.6)";
    e.currentTarget.style.background = "rgba(139,92,246,0.05)";
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.currentTarget.style.borderColor = "rgba(139,92,246,0.2)";
    e.currentTarget.style.background = "rgba(139,92,246,0.02)";
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.style.borderColor = "rgba(139,92,246,0.2)";
    e.currentTarget.style.background = "rgba(139,92,246,0.02)";

    const files = e.dataTransfer.files;
    if (files.length > 0) {
      handleFileSelect(files[0]);
    }
  };

  const startProcessing = () => {
    setStep("processing");
    setProcessingProgress(0);
    trackEvent("processing_started");

    let progress = 0;
    timerRef.current = setInterval(() => {
      progress += 1.5;
      setProcessingProgress(Math.min(progress, 100));

      if (progress >= 25) setProcessingItems(prev => [true, prev[1], prev[2], prev[3]]);
      if (progress >= 50) setProcessingItems(prev => [prev[0], true, prev[2], prev[3]]);
      if (progress >= 75) setProcessingItems(prev => [prev[0], prev[1], true, prev[3]]);
      if (progress >= 95) setProcessingItems(prev => [prev[0], prev[1], prev[2], true]);

      if (progress >= 100) {
        clearInterval(timerRef.current);
        trackEvent("processing_completed");
        setTimeout(() => setStep("done"), 600);
      }
    }, 80);
  };

  useEffect(() => () => clearInterval(timerRef.current), []);

  const downloadClaudeFormat = () => {
    const content = generateClaudeOutput(parsedData);
    const blob = new Blob([content], { type: 'text/markdown' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'claude-migration.md';
    a.click();
    URL.revokeObjectURL(url);
    trackEvent("download_claude");
  };

  const downloadFullArchive = () => {
    const json = JSON.stringify(parsedData.conversations, null, 2);
    const blob = new Blob([json], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'chatgpt-conversations.json';
    a.click();
    URL.revokeObjectURL(url);
    trackEvent("download_archive");
  };

  // ─── Render ──────────────────────────────────────────────────────────────

  return (
    <div style={{ minHeight: "100vh", position: "relative", fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" }}>
      <GlobalStyles />
      <AnimatedBackground />

      {/* Leave warning modal */}
      {showLeaveWarning && <LeaveWarningOverlay onStay={() => setShowLeaveWarning(false)} />}

      {/* Buy Me a Coffee floating widget — visible on main page */}
      {page === "main" && <BuyMeCoffeeWidget />}

      {/* Admin pages */}
      {page === "admin-login" && (
        <AdminLogin onLogin={() => setPage("admin")} onBack={() => setPage("main")} />
      )}
      {page === "admin" && (
        <AdminDashboard onLogout={() => setPage("main")} />
      )}

      {/* Main migration flow */}
      {page === "main" && (
        <div style={{ position: "relative", zIndex: 1, maxWidth: "720px", margin: "0 auto", padding: "48px 24px" }}>

          {/* Header */}
          <div style={{ textAlign: "center", marginBottom: "48px", animation: "fadeUp 0.6s ease both" }}>
            <div style={{
              display: "inline-flex", alignItems: "center", gap: "8px",
              background: "rgba(139,92,246,0.1)", border: "1px solid rgba(139,92,246,0.2)",
              borderRadius: "100px", padding: "6px 16px", marginBottom: "24px",
              fontSize: "12px", fontWeight: 600, color: "#a78bfa", letterSpacing: "0.05em", textTransform: "uppercase"
            }}>
              <ShieldIcon /> End-to-end encrypted
            </div>
            <h1 style={{
              fontSize: "clamp(28px, 5vw, 42px)", fontWeight: 700, color: "#fff",
              margin: "0 0 12px 0", lineHeight: 1.2, letterSpacing: "-0.02em"
            }}>
              Migrate to <span style={{ background: "linear-gradient(135deg, #d97757, #c4856e)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>Claude</span>
            </h1>
            <p style={{ color: "rgba(255,255,255,0.45)", fontSize: "16px", margin: 0, lineHeight: 1.6 }}>
              Transfer your entire ChatGPT history to Claude in one click.
              <br />Projects, conversations, and settings — all preserved.
            </p>
          </div>

          {/* Step indicator */}
          <div style={{
            display: "flex", alignItems: "center", justifyContent: "center",
            marginBottom: "40px", animation: "fadeUp 0.6s ease 0.1s both"
          }}>
            {["Upload", "Process", "Done"].map((label, i) => {
              const active = (i === 0 && step === "upload") || (i === 1 && step === "processing") || (i === 2 && step === "done");
              const completed = (i === 0 && step !== "upload") || (i === 1 && step === "done");
              return (
                <div key={label} style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "6px" }}>
                    <div style={{
                      width: "32px", height: "32px", borderRadius: "50%",
                      background: completed ? "#34d399" : active ? "rgba(139,92,246,0.3)" : "rgba(255,255,255,0.05)",
                      border: `2px solid ${completed ? "#34d399" : active ? "#8b5cf6" : "rgba(255,255,255,0.1)"}`,
                      display: "flex", alignItems: "center", justifyContent: "center",
                      color: completed ? "#fff" : active ? "#8b5cf6" : "rgba(255,255,255,0.3)",
                      fontSize: "13px", fontWeight: 600, transition: "all 0.4s ease"
                    }}>
                      {completed ? <CheckIcon /> : i + 1}
                    </div>
                    <span style={{ fontSize: "11px", fontWeight: 500, letterSpacing: "0.03em", color: active ? "#fff" : "rgba(255,255,255,0.3)" }}>
                      {label}
                    </span>
                  </div>
                  {i < 2 && (
                    <div style={{
                      width: "60px", height: "2px", margin: "0 12px", marginBottom: "20px",
                      background: completed ? "#34d399" : "rgba(255,255,255,0.08)",
                      borderRadius: "1px", transition: "all 0.4s ease"
                    }} />
                  )}
                </div>
              );
            })}
          </div>

          {/* ─── Upload Step ─── */}
          {step === "upload" && (
            <>
              <Card delay={0.2}>
                <h2 style={{ color: "#fff", fontSize: "20px", fontWeight: 600, margin: "0 0 8px 0" }}>
                  Export Your ChatGPT Data
                </h2>
                <p style={{ color: "rgba(255,255,255,0.4)", fontSize: "14px", margin: "0 0 24px 0" }}>
                  To get started, export your data from ChatGPT and upload it here.
                </p>

                <div style={{
                  background: "rgba(139,92,246,0.05)", border: "2px dashed rgba(139,92,246,0.2)",
                  borderRadius: "16px", padding: "48px 32px", textAlign: "center",
                  cursor: "pointer", transition: "all 0.3s ease",
                  marginBottom: "24px"
                }}
                  onDragOver={handleDragOver}
                  onDragLeave={handleDragLeave}
                  onDrop={handleDrop}
                  onClick={() => fileInputRef.current?.click()}
                >
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept=".zip"
                    onChange={(e) => handleFileSelect(e.target.files?.[0])}
                    style={{ display: "none" }}
                  />

                  <div style={{ color: "#8b5cf6", marginBottom: "16px" }}>
                    <UploadIcon />
                  </div>
                  <h3 style={{ color: "#fff", fontSize: "18px", fontWeight: 600, margin: "0 0 8px 0" }}>
                    {parsedData ? "File Selected" : "Drop your ZIP file here"}
                  </h3>
                  <p style={{ color: "rgba(255,255,255,0.4)", fontSize: "14px", margin: 0 }}>
                    {parsedData
                      ? `${parsedData.count} conversations found`
                      : "Or click to browse"
                    }
                  </p>
                </div>

                {uploadError && (
                  <div style={{
                    padding: "12px 16px", background: "rgba(239,68,68,0.1)",
                    border: "1px solid rgba(239,68,68,0.2)", borderRadius: "10px",
                    color: "#ef4444", fontSize: "13px", marginBottom: "20px",
                    display: "flex", alignItems: "flex-start", gap: "8px"
                  }}>
                    <AlertIcon style={{ marginTop: "2px", flexShrink: 0 }} />
                    <div>{uploadError}</div>
                  </div>
                )}

                {parsedData && (
                  <div style={{
                    background: "rgba(52,211,153,0.06)", border: "1px solid rgba(52,211,153,0.15)",
                    borderRadius: "12px", padding: "16px", marginBottom: "24px"
                  }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px" }}>
                      <CheckIcon size={16} style={{ color: "#34d399" }} />
                      <span style={{ color: "#34d399", fontWeight: 600, fontSize: "14px" }}>Ready to process</span>
                    </div>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", fontSize: "13px", color: "rgba(255,255,255,0.6)" }}>
                      <div>Conversations: <span style={{ color: "#fff", fontWeight: 600 }}>{parsedData.count}</span></div>
                      <div>Messages: <span style={{ color: "#fff", fontWeight: 600 }}>{parsedData.totalMessages}</span></div>
                      <div style={{ gridColumn: "1 / -1" }}>Date range: <span style={{ color: "#fff", fontWeight: 600 }}>{parsedData.dateRange}</span></div>
                    </div>
                  </div>
                )}

                <div style={{
                  background: "rgba(255,255,255,0.02)", border: "1px solid rgba(255,255,255,0.06)",
                  borderRadius: "12px", padding: "16px", marginBottom: "24px"
                }}>
                  <p style={{ color: "rgba(255,255,255,0.5)", fontSize: "13px", margin: 0, lineHeight: 1.6 }}>
                    <strong style={{ color: "#fff" }}>How to export your data:</strong><br />
                    1. Go to ChatGPT → Settings → Data Controls<br />
                    2. Click "Export data"<br />
                    3. Wait for the ZIP file to download<br />
                    4. Upload it here
                  </p>
                </div>

                <button
                  onClick={startProcessing}
                  disabled={!parsedData}
                  style={{
                    width: "100%", padding: "18px 32px",
                    background: parsedData ? "linear-gradient(135deg, #8b5cf6, #7c3aed)" : "rgba(255,255,255,0.05)",
                    color: parsedData ? "#fff" : "rgba(255,255,255,0.2)",
                    border: `1px solid ${parsedData ? "rgba(139,92,246,0.4)" : "rgba(255,255,255,0.06)"}`,
                    borderRadius: "14px", fontSize: "16px", fontWeight: 600,
                    cursor: parsedData ? "pointer" : "not-allowed",
                    display: "flex", alignItems: "center", justifyContent: "center", gap: "10px",
                    transition: "all 0.4s ease",
                    boxShadow: parsedData ? "0 8px 32px rgba(139,92,246,0.25)" : "none"
                  }}
                >
                  <ArrowRight /> Begin Conversion
                </button>
              </Card>
            </>
          )}

          {/* ─── Processing Step ─── */}
          {step === "processing" && (
            <Card delay={0}>
              <h2 style={{ color: "#fff", fontSize: "20px", fontWeight: 600, margin: "0 0 6px 0" }}>
                Processing your data...
              </h2>
              <p style={{ color: "rgba(255,255,255,0.4)", fontSize: "14px", margin: "0 0 24px 0" }}>
                Converting your ChatGPT history for Claude
              </p>

              {/* Progress bar */}
              <div style={{
                background: "rgba(255,255,255,0.05)", borderRadius: "8px",
                height: "10px", overflow: "hidden", marginBottom: "12px"
              }}>
                <div style={{
                  height: "100%", borderRadius: "8px",
                  background: "linear-gradient(90deg, #8b5cf6, #a78bfa, #d97757)",
                  backgroundSize: "200% 100%", animation: "shimmer 2s linear infinite",
                  width: `${processingProgress}%`, transition: "width 0.3s ease",
                  boxShadow: "0 0 20px rgba(139,92,246,0.4)"
                }} />
              </div>
              <div style={{ fontSize: "14px", color: "#fff", textAlign: "center", marginBottom: "6px", fontWeight: 600 }}>
                {Math.round(processingProgress)}%
              </div>
              <div style={{
                fontSize: "12px", color: "rgba(255,255,255,0.35)", textAlign: "center", marginBottom: "24px",
                display: "flex", alignItems: "center", justifyContent: "center", gap: "6px"
              }}>
                <WarningIcon /> Please keep this page open until processing completes
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <ProcessItem label="Parsing conversations" done={processingItems[0]} delay={0.1} />
                <ProcessItem label="Extracting custom instructions" done={processingItems[1]} delay={0.2} />
                <ProcessItem label="Formatting for Claude Projects" done={processingItems[2]} delay={0.3} />
                <ProcessItem label="Generating output files" done={processingItems[3]} delay={0.4} />
              </div>
            </Card>
          )}

          {/* ─── Done Step ─── */}
          {step === "done" && (
            <>
              {/* Success summary card */}
              <Card delay={0}>
                <div style={{ textAlign: "center" }}>
                  <div style={{
                    width: "72px", height: "72px", borderRadius: "50%",
                    background: "rgba(52,211,153,0.1)", border: "2px solid rgba(52,211,153,0.3)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    margin: "0 auto 20px", animation: "checkPop 0.5s ease", color: "#34d399"
                  }}>
                    <CheckIcon size={36} />
                  </div>
                  <h2 style={{ color: "#fff", fontSize: "24px", fontWeight: 700, margin: "0 0 8px 0" }}>
                    Conversion Complete!
                  </h2>
                  <p style={{ color: "rgba(255,255,255,0.45)", fontSize: "15px", margin: "0 0 24px 0", lineHeight: 1.6 }}>
                    Your ChatGPT data has been successfully converted for Claude.
                  </p>
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))", gap: "12px", marginBottom: "24px" }}>
                    {[
                      { label: "Conversations", value: parsedData?.count.toString() || "0", color: "#8b5cf6" },
                      { label: "Messages", value: parsedData?.totalMessages.toString() || "0", color: "#d97757" },
                      { label: "Projects", value: "Ready", color: "#34d399" },
                      { label: "Preferences", value: "Preserved", color: "#60a5fa" }
                    ].map(item => (
                      <div key={item.label} style={{
                        padding: "16px", borderRadius: "12px",
                        background: item.color + "08", border: `1px solid ${item.color}20`
                      }}>
                        <div style={{ color: item.color, fontSize: "24px", fontWeight: 700 }}>{item.value}</div>
                        <div style={{ color: "rgba(255,255,255,0.4)", fontSize: "12px", marginTop: "4px" }}>{item.label}</div>
                      </div>
                    ))}
                  </div>

                  {/* Download buttons */}
                  <div style={{ display: "flex", gap: "12px", marginBottom: "24px" }}>
                    <button onClick={downloadClaudeFormat} style={{
                      flex: 1, padding: "14px 24px",
                      background: "linear-gradient(135deg, #d97757, #c4856e)",
                      color: "#fff", border: "none", borderRadius: "12px",
                      fontSize: "14px", fontWeight: 600, cursor: "pointer",
                      boxShadow: "0 8px 32px rgba(217,119,87,0.25)",
                      transition: "all 0.3s ease"
                    }}
                    onMouseEnter={e => e.target.style.transform = "translateY(-2px)"}
                    onMouseLeave={e => e.target.style.transform = "translateY(0)"}
                    >
                      Download for Claude
                    </button>
                    <button onClick={downloadFullArchive} style={{
                      flex: 1, padding: "14px 24px",
                      background: "rgba(255,255,255,0.08)",
                      color: "#fff", border: "1px solid rgba(255,255,255,0.15)", borderRadius: "12px",
                      fontSize: "14px", fontWeight: 600, cursor: "pointer",
                      transition: "all 0.3s ease"
                    }}
                    onMouseEnter={e => { e.target.style.background = "rgba(255,255,255,0.12)"; e.target.style.transform = "translateY(-2px)"; }}
                    onMouseLeave={e => { e.target.style.background = "rgba(255,255,255,0.08)"; e.target.style.transform = "translateY(0)"; }}
                    >
                      Download Archive
                    </button>
                  </div>

                  <div style={{
                    background: "rgba(139,92,246,0.06)", border: "1px solid rgba(139,92,246,0.15)",
                    borderRadius: "12px", padding: "16px", marginBottom: "24px"
                  }}>
                    <p style={{ color: "rgba(255,255,255,0.5)", fontSize: "13px", margin: 0, lineHeight: 1.6 }}>
                      <strong style={{ color: "#fff" }}>Next steps:</strong><br />
                      Open Claude → Create a new Project → Paste the downloaded content into Project Instructions
                    </p>
                  </div>
                </div>
              </Card>

              {/* ─── Thank You + Donation CTA ─── */}
              {!donationDismissed && (
                <div style={{
                  marginTop: "24px", animation: "fadeUp 0.6s ease 0.4s both",
                  background: "rgba(255,255,255,0.03)", backdropFilter: "blur(20px)",
                  border: "1px solid rgba(251,191,36,0.15)", borderRadius: "24px",
                  padding: "40px 32px", textAlign: "center",
                  position: "relative", overflow: "hidden"
                }}>
                  {/* Subtle golden glow in background */}
                  <div style={{
                    position: "absolute", top: "-40%", left: "50%", transform: "translateX(-50%)",
                    width: "300px", height: "300px",
                    background: "radial-gradient(circle, rgba(251,191,36,0.06) 0%, transparent 70%)",
                    pointerEvents: "none"
                  }} />

                  <div style={{ position: "relative", zIndex: 1 }}>
                    {/* Thank you heading */}
                    <h2 style={{
                      color: "#fff", fontSize: "22px", fontWeight: 700,
                      margin: "0 0 8px 0", lineHeight: 1.3
                    }}>
                      Thank you for using our migration tool!
                    </h2>

                    {/* Large Buy Me a Coffee CTA box */}
                    <a
                      href="https://buymeacoffee.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={() => trackEvent("donation_clicked")}
                      style={{
                        display: "block", textDecoration: "none",
                        background: "linear-gradient(135deg, #FFDD00, #FFB800)",
                        borderRadius: "16px", padding: "28px 24px",
                        cursor: "pointer", transition: "all 0.3s ease",
                        boxShadow: "0 8px 32px rgba(255,221,0,0.2)",
                        marginBottom: "16px", marginTop: "24px"
                      }}
                    >
                      <div style={{
                        display: "flex", alignItems: "center", justifyContent: "center",
                        gap: "12px", marginBottom: "12px"
                      }}>
                        <CoffeeIcon size={32} />
                        <span style={{
                          color: "#000", fontSize: "22px", fontWeight: 800, letterSpacing: "-0.01em"
                        }}>
                          Buy Me a Coffee
                        </span>
                      </div>
                      <p style={{
                        color: "rgba(0,0,0,0.6)", fontSize: "14px",
                        margin: 0, lineHeight: 1.5, maxWidth: "400px", marginLeft: "auto", marginRight: "auto"
                      }}>
                        If you found this tool valuable, feel free to buy me a coffee — it's greatly appreciated!
                      </p>
                      <div style={{
                        marginTop: "14px", display: "inline-flex", alignItems: "center", gap: "6px",
                        background: "rgba(0,0,0,0.1)", borderRadius: "100px", padding: "6px 16px",
                        fontSize: "13px", fontWeight: 700, color: "rgba(0,0,0,0.7)"
                      }}>
                        Sure, I'd love to! &rarr;
                      </div>
                    </a>

                    {/* Not Right Now — small dismiss button */}
                    <button
                      onClick={() => { setDonationDismissed(true); trackEvent("donation_dismissed"); }}
                      style={{
                        background: "none", border: "none",
                        color: "rgba(255,255,255,0.3)", fontSize: "13px",
                        cursor: "pointer", padding: "8px 16px",
                        transition: "color 0.3s ease",
                        fontWeight: 500, letterSpacing: "0.01em"
                      }}
                      onMouseEnter={e => e.target.style.color = "rgba(255,255,255,0.55)"}
                      onMouseLeave={e => e.target.style.color = "rgba(255,255,255,0.3)"}
                    >
                      Not Right Now
                    </button>
                  </div>
                </div>
              )}
            </>
          )}

          {/* Footer */}
          <div style={{
            textAlign: "center", marginTop: "48px", color: "rgba(255,255,255,0.2)", fontSize: "12px",
            animation: "fadeUp 0.6s ease 0.4s both"
          }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px", marginBottom: "6px" }}>
              <ShieldIcon size={14} /> Your data is encrypted in transit and never stored on our servers
            </div>
            <div style={{ marginBottom: "12px" }}>v1.0.0 · Open Source · MIT License</div>
            <button
              onClick={() => setPage("admin-login")}
              style={{
                background: "none", border: "none", color: "rgba(255,255,255,0.15)",
                fontSize: "11px", cursor: "pointer", padding: "4px 8px",
                transition: "color 0.3s"
              }}
              onMouseEnter={e => e.target.style.color = "rgba(255,255,255,0.4)"}
              onMouseLeave={e => e.target.style.color = "rgba(255,255,255,0.15)"}
            >
              Admin
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
